<template lang="pug">
  #companion-preview-card
    RouterLink(:to="redirectTo")
      WtTile(parent)
        .flex-container
          slot(name="module-header")
          .cover-art-container(:style="{ backgroundColor: backgroundColor }")
            img.is-square(:src="previewImage" :alt="'Not available'")
          .custom-content-box
            p.custom-tag(v-if="tag") {{ moduleType!="workshop" ? tag : formatDate(tag) }}
            p.custom-title(v-if="title") {{ title }}
            p.custom-subheading(v-if="moduleType !=='workshop'") {{ subTitle }}
          .horizontal-divider(v-if="duration")
          .timer-container(v-if="duration")
            WtSvgIcon(icon="icon_time" width="16px" height="16px" style="padding-top: 4px;")
            span {{ duration }}

</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import { formatDate } from "@/utils/dateFormatter";

export default {
  name: "PreviewCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    redirectTo: { type: [Object, String], required: true },
    moduleType: { type: String, required: true },
    moduleIcon: { type: String, required: true },
    id: { type: String, default: "" },
    tag: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    duration: { type: String, default: "" },
    previewImage: {
      type: String,
      default: ""
    },
    backgroundColor: { type: String, default: "a3d8ca" }
  },
  data() {
    return {};
  },
  methods: {
    formatDate
  }
};
</script>
<style scoped>
#companion-preview-card {
  border-radius: 1rem;
  background-color: white !important;
  font-family: Manrope;
  font-style: normal;
  font-weight: 600;
  height: min-content !important;
  width: 670px;

  .tile.is-parent {
    padding: 1.5rem !important;
  }

  .flex-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    width: 670px;

    .module-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .catergory-icon {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
    }

    .category {
      color: #1b1d20;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px; /* 125% */
      font-family: Manrope;
      font-style: normal;
      letter-spacing: 0.25px;
    }

    .cover-art-container {
      display: flex;
      width: 100% !important;
      justify-content: space-around;
      align-items: center !important;
      border-radius: 1rem;
      border: 1px solid #fff;
      background: #fff;
    }

    .cover-art-container img {
      border-radius: 0.5rem !important;
      height: 220px !important;
    }

    .custom-content-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start !important;
      gap: 6px !important;
    }

    .custom-title {
      color: #1b1d20;
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0.18px;
      margin: 0rem !important;
      vertical-align: middle;
    }

    .custom-tag {
      color: #5a5c60;
      padding: 0rem;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.25px;
      margin: 0rem !important;
      vertical-align: middle;
    }
    .custom-subheading {
      color: #5a5c60;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.25px;
      margin: 0rem !important;
      vertical-align: middle;
    }
    .timer-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      color: #5a5c60;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
    }

    .horizontal-divider {
      display: flex;
      height: 0.762px;
    }

    .view-button {
      display: flex;
      padding: 6px 8px;
      justify-content: center;
      align-items: center;
      gap: 6px;
      border-radius: 6px;
      background: #2972f0;
      color: #fff;
      text-align: center;
      font-family: Manrope;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 133.333% */
    }
  }
}

@media screen and (max-width: 768px) {
  #companion-preview-card {
    width: 100%;
    .flex-container {
      width: 100%;
      .cover-art-container img {
        height: 150px !important;
      }
    }
  }
}
</style>
